<app-auth-page-layout>
  <div class="flex flex-col flex-1 w-full overflow-y-auto lg:w-1/2 no-scrollbar">
    <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto py-8" aria-live="polite">

      @switch (state()) {
        @case ('checking') {
          <div class="flex flex-col items-center gap-4 text-center" role="status">
            <div class="w-10 h-10 border-4 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
            <h1 class="text-xl font-semibold text-gray-800 dark:text-white/90">Confirming your result…</h1>
            <p class="text-sm text-gray-500 dark:text-gray-400">This only takes a few seconds.</p>
          </div>
        }

        @case ('approved') {
          <div class="flex flex-col items-center gap-4 text-center">
            <div class="flex h-16 w-16 items-center justify-center rounded-full bg-success-50 dark:bg-success-500/10">
              <svg class="h-8 w-8 text-success-600" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 class="text-2xl font-semibold text-gray-800 dark:text-white/90">You’re verified</h1>
            <p class="text-sm text-gray-500 dark:text-gray-400">Thanks for confirming your age. Taking you in now.</p>
            <button type="button" (click)="continue()"
              class="mt-2 rounded-xl bg-brand-500 px-6 py-2.5 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30">
              Continue
            </button>
          </div>
        }

        @case ('in-progress') {
          <div class="text-center">
            <h1 class="mb-3 text-2xl font-semibold text-gray-800 dark:text-white/90">Verification not finished yet</h1>
            <p class="mb-6 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
              It looks like the check wasn’t completed. You can pick up where you left off.
            </p>
            <button type="button" (click)="retry()"
              class="w-full rounded-xl bg-brand-500 px-4 py-3 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30">
              Continue verification
            </button>
          </div>
        }

        @case ('failed') {
          <div class="text-center">
            <h1 class="mb-3 text-2xl font-semibold text-gray-800 dark:text-white/90">We couldn’t confirm your age</h1>
            <p class="mb-6 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
              None of the attempts were able to confirm you’re 18 or over. You can start a new check,
              and a different method (such as a photo ID) often works when another didn’t.
            </p>
            <button type="button" (click)="retry()"
              class="w-full rounded-xl bg-brand-500 px-4 py-3 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30">
              Try again
            </button>
          </div>
        }

        @case ('expired') {
          <div class="text-center">
            <h1 class="mb-3 text-2xl font-semibold text-gray-800 dark:text-white/90">This link has expired</h1>
            <p class="mb-6 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
              Verification links stay open for six hours. Start a new one to continue.
            </p>
            <button type="button" (click)="retry()"
              class="w-full rounded-xl bg-brand-500 px-4 py-3 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30">
              Start again
            </button>
          </div>
        }

        @case ('error') {
          <div class="text-center">
            <h1 class="mb-3 text-2xl font-semibold text-gray-800 dark:text-white/90">Something went wrong</h1>
            <p class="mb-6 text-sm leading-relaxed text-gray-500 dark:text-gray-400">{{ errorMessage() }}</p>
            <button type="button" (click)="retry()"
              class="w-full rounded-xl bg-brand-500 px-4 py-3 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30">
              Back to verification
            </button>
          </div>
        }
      }
    </div>
  </div>
</app-auth-page-layout>
